import { Icons, Images } from "assets";
import classNames from "classnames";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomButton from "shared/components/common/customButton";
import CustomInput from "shared/components/common/customInput";
import { routeConstant } from "shared/routes/routeConstant";
import { ResetPasswordVS } from "shared/utils/validation";
import styles from "./styles.module.scss";
import { useEffect } from "react";
import { ResetPasswordService } from "shared/services/auth";
import { toastMessage } from "shared/components/common/toast";

const initialValues: ResetPasswordType = {
  password: "",
  confirmPassword: "",
};

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: ResetPasswordVS,
    onSubmit: (value, action) => {
      handleResetPassword();
    },
  });

  const {
    handleChange,
    handleSubmit,
    values,
    touched,
    errors,
    isSubmitting,
    setSubmitting,
  } = formik;

  const handleResetPassword = () => {
    setSubmitting(true);
    let token = decodeURIComponent(location?.search?.split("=")[1]);
    ResetPasswordService({
      password: values.password,
      token: token,
    })
      .then(() => {
        toastMessage("success", "Password reset successfully");
        navigate(routeConstant.login.path);
        resetForm();
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    if (location?.search?.split("=")[0].split("?")[1] !== "token") {
      navigate(-1);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <main className={styles.bg}>
      <div className={classNames(styles.customContainer)}>
        <div className={classNames(styles.mainContainer, "py-5")}>
          <section
            className={classNames(
              "w-full lg:w-1/2 flex flex-col items-center  relative ",
              styles.leftContainer
            )}
          >
            <Link
              to={routeConstant.login.path}
              className={classNames(styles.logoContainer)}
            >
              <Icons.Logo />
            </Link>
            <div
              className={classNames(
                "flex items-center w-full justify-center m-auto"
              )}
            >
              <form
                className={classNames(styles.formContainer)}
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div className={classNames("flex flex-col items-start gap-3")}>
                  <h1 className={classNames(styles.title)}>Set New Password</h1>
                  <p className={classNames(styles.subTitle)}>
                    Your new password must be different from previously used
                    passwords.
                  </p>
                </div>
                <div className={classNames("flex flex-col gap-1")}>
                  <CustomInput
                    label="Password"
                    placeholder="Password"
                    required
                    isPassword
                    Icon={Icons.Lock}
                    type="password"
                    value={values.password}
                    error={
                      touched.password && errors.password ? errors.password : ""
                    }
                    onChange={handleChange("password")}
                    customLabelStyle={classNames(styles.labelStyle)}
                  />
                  <CustomInput
                    label="Confirm Password"
                    placeholder="Confirm Password"
                    required
                    isPassword
                    Icon={Icons.Lock}
                    type="password"
                    value={values.confirmPassword}
                    error={
                      touched.confirmPassword && errors.confirmPassword
                        ? errors.confirmPassword
                        : ""
                    }
                    onChange={handleChange("confirmPassword")}
                    customLabelStyle={classNames(styles.labelStyle)}
                  />
                </div>
                <div className={classNames("flex flex-col items-center gap-6")}>
                  <CustomButton
                    title="Reset Password"
                    style={{ width: "100%" }}
                    onClick={() => handleSubmit()}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                  />
                </div>
              </form>
            </div>
          </section>
          <section
            className={classNames(
              "w-1/2 hidden lg:flex relative flex-col justify-between overflow-hidden",
              styles.rightContainer
            )}
          >
            <div
              className={classNames(
                "flex flex-col items-start gap-3 px-5 py-10 justify-center"
              )}
            >
              <h1 className={classNames(styles.title)}>
                Access Your <span>Job Evaluation</span> Portal
              </h1>
              <p className={classNames(styles.subTitle)}>
                Sign in to your account to explore detailed job evaluations,
                manage your submissions. Our platform is designed to support
                your career advancement with ease and precision
              </p>
            </div>
            <img
              src={Images.LoginPlaceholder}
              alt=""
              className={classNames(styles.assetImg)}
            />
          </section>
        </div>
      </div>
    </main>
  );
};

export default ResetPassword;
function resetForm() {
  throw new Error("Function not implemented.");
}
